export function mascaraTelefone (telefone){
    let telefoneComMascara = '';
    const telefoneString = `${telefone}`;

    if(telefoneString.length === 10){
        const numerosTelefone = telefoneString.split('');
        const DDD =  numerosTelefone.splice(0,2).join('');

        numerosTelefone.splice(4,0,'-');
        telefoneComMascara = `(${DDD}) ${numerosTelefone.join('')}`;
    }

    if(telefoneString.length === 11){
        const numerosTelefone = telefoneString.split('');
        const DDD =  numerosTelefone.splice(0,2).join('');
        const digito = numerosTelefone.splice(0,1);

        numerosTelefone.splice(4,0,'-');
        telefoneComMascara = `(${DDD}) ${digito} ${numerosTelefone.join('')}`;
    }

    return telefoneComMascara;
}
